import { Dimensions, StyleSheet } from 'react-native'
import theme from '../../../theme'

const width = (Dimensions.get('window').width - 30) / 5

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginVertical: 5,
        paddingHorizontal: 10,
        borderRadius: 10,
    },
    cantainerDataUser: {
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
    },
    avatar: {
        width: 34,
        height: 34,
        borderRadius: 17,
        marginRight: 0,
    },
    userName: {
        fontSize: 15,
        fontWeight: '400',
        marginHorizontal: 10,
    },
    containerReactionItem: {
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
        width: width,
        justifyContent: 'center',
    },
    reactionIcon: {
        width: 20,
        height: 20,
        marginHorizontal: 5,
    },
    reactionSelected: {
        width: 28,
        height: 28,
        marginRight: 6,
    },
    reactionUnselected: {
        width: 24,
        height: 24,
        marginRight: 6,
    },
    heartIcon: {
        width: 24,
        height: 24,
        marginRight: 6,
    },
    containerReactionsModal: {
        paddingHorizontal: 15,
        paddingTop: 15,
    },
    contentContainerStyle: {
        alignItems: 'justify-content',
    },
    subtitleSection: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginHorizontal: 10,
        marginTop: 10,
        paddingTop: 10,
        borderTopColor: theme.colors.extraLightGray,
        borderTopWidth: 1,
        marginBottom: 10,
    },
    messageContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 50,
        paddingHorizontal: 10,
        paddingBottom: 10,
        borderRadius: 5,
    },
    imageAsset: {
        width: 120,
        height: 120,
    },
    titleText: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 25,
    },
    descriptionText: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 25,
        paddingBottom: 90,
    },
    interactionRight: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 5,
    },
    interactionsLine: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: 0,
    },
    footerPost: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginTop: 8,
        marginBottom: 6,
    },
    reactionSector: {
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: 10,
    },
    iconPosts: {
        width: 24,
        height: 24,
        paddingLeft: 7,
        marginTop: 0,
        alignItems: 'center',
    },
    iconReactionPosts: {
        width: 24,
        height: 24,
        marginRight: 7,
        marginTop: 0,
        alignItems: 'center',
    },
    footerPostTexts: {
        flexDirection: 'row',
        marginRight: 10,
    },
    reactionCountSelected: {
        color: theme.colors.colorPrimary,
        marginStart: 3,
        paddingBottom: 0,
        fontWeight: '800',
    },
    reactionCountUnselected: {
        color: theme.colors.textSecondary,
        marginStart: 3,
        paddingBottom: 0,
        fontWeight: '500',
    },
    optionSelected: {
        width: 24,
        height: 24,
        marginRight: 6,
    },
    optionUnselected: {
        width: 28,
        height: 28,
        marginRight: 6,
    },
    spacer1: { height: 12 },
})
export default styles
